__turbopack_context__.v({
  "arrow": "Callout-module__2z9qhq__arrow",
  "arrowColor__grey": "Callout-module__2z9qhq__arrowColor__grey",
  "arrowColor__orange": "Callout-module__2z9qhq__arrowColor__orange",
  "arrowColor__teal": "Callout-module__2z9qhq__arrowColor__teal",
  "arrow__bottom": "Callout-module__2z9qhq__arrow__bottom",
  "arrow__top": "Callout-module__2z9qhq__arrow__top",
  "callout": "Callout-module__2z9qhq__callout",
  "enter": "Callout-module__2z9qhq__enter",
  "exit": "Callout-module__2z9qhq__exit",
  "origin__bottom": "Callout-module__2z9qhq__origin__bottom",
  "origin__top": "Callout-module__2z9qhq__origin__top",
  "positioned": "Callout-module__2z9qhq__positioned",
});
